export const HeaderConstants = {
    HeaderBanner: {
        RELEASENOTESINTERNAL: 'RELEASENOTESINTERNAL',
        RELEASENOTESEXTERNAL: 'RELEASENOTESEXTERNAL',
        RELEASENOTESVIDEOINTERNAL: 'RELEASENOTESVIDEOINTERNAL',
        RELEASENOTESVIDEOEXTERNAL: 'RELEASENOTESVIDEOEXTERNAL',
    },
};